import { createSelector } from '@ngrx/store';
import { ILoginData, IOtpData } from '@partners/api';
import { IRootState } from '../../../root';
import { IAuthLoginState, IAuthOtpState } from './auth.state';

export class AuthSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly authOtpState = (state: IRootState): IAuthOtpState => {
    return state.otp as IAuthOtpState;
  };

  static readonly authLoginState = (state: IRootState): IAuthLoginState => {
    return state.login as IAuthLoginState;
  };

  static readonly otpModel = createSelector(AuthSelectors.authOtpState, (otpState: IAuthOtpState) => {
    return otpState.model;
  });

  static readonly otpData = createSelector(AuthSelectors.authOtpState, (otpState: IAuthOtpState) => {
    return otpState.data;
  });

  static readonly otpSendAttemptsCount = createSelector(AuthSelectors.authOtpState, (otpState: IAuthOtpState) => {
    return otpState.otpSendAttemptsCount || 0;
  });

  static readonly loginModel = createSelector(AuthSelectors.authLoginState, (loginState: IAuthLoginState) => {
    return loginState.model;
  });

  static readonly loginData = createSelector(AuthSelectors.authLoginState, (loginState: IAuthLoginState) => {
    return loginState.data;
  });

  static readonly customerLoginData = createSelector(AuthSelectors.loginData, (loginData: ILoginData) => {
    return loginData?.customer;
  });

  static readonly accountLoginData = createSelector(AuthSelectors.loginData, (loginData: ILoginData) => {
    return loginData?.debits;
  });

  static readonly isLoggedIn = createSelector(AuthSelectors.loginData, (loginData: ILoginData) => {
    return Boolean(loginData?.customer);
  });
  static readonly token = createSelector(AuthSelectors.otpData, (otpData: IOtpData) => {
    return otpData?.token;
  });
}
